import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {JobDetailsPage} from '../../../jobs/job-details-page'

export const Route = createFileRoute('/_app/jobs/$jobId')({
    component: JobDetailsRoute,
})

function JobDetailsRoute() {
    const {jobId} = Route.useParams()

    return (
        <Container size="lg" py="xl">
            <JobDetailsPage jobId={jobId} />
        </Container>
    )
}
